import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Card, Space, Modal, Progress, message, Spin, Tooltip } from 'antd';
import { InputGroup, Form, Badge } from 'react-bootstrap';
import { SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import AddServices from './Components/AddServices';
import axios from 'axios';
import { oneKlicks } from '../SDK/oneclick';
import { OneKlicksFileSDK } from '../SDK/OneKlicksFileSDK';
import ImageShow from '../Uitiles/ImageShow';
import { getuserdata } from '../services/apiService';
import EditServices from './Components/EditServices';
import decodeHtml from '../Uitiles/decodeHtml';
import SpecialityName from './Components/SpecialityName';
import { debugLog } from '../utils/debug';
import Paginationnew from '../Uitiles/Paginationnew';

// Service Model
class ServiceModel {
    constructor(data = {}) {
        this.id = data.id || '';
        this.old_id = data.old_id || '';
        this.name = data.name || '';
        this.slug = data.slug || '';
        this.color = data.color || '';
        this.url = data.url || '';
        this.speciality_id = data.speciality_id || '';
        this.speciality = data.speciality || '';
        this.totalUse = data.totalUse || 0;
        this.status = data.status || 'publish';
        this.country = data.country || '';
        this.created_at = data.created_at || new Date().toISOString();
        this.updated_at = data.updated_at || new Date().toISOString();
    }

    toJSON() {
        return {
            id: this.id,
            old_id: this.old_id,
            name: this.name,
            slug: this.slug,
            color: this.color,
            url: this.url,
            speciality_id: this.speciality_id,
            speciality: this.speciality,
            totalUse: this.totalUse,
            status: this.status,
            country: this.country,
            created_at: this.created_at,
            updated_at: this.updated_at
        };
    }

    static fromAPI(data) {
        return new ServiceModel({
            id: data.id,
            old_id: data.old_id,
            name: data.name,
            slug: data.slug,
            color: data.color,
            url: data.url,
            speciality_id: data.speciality_id,
            speciality: data.speciality[0],
            totalUse: data.totalUse,
            status: data.status,
            country: data.country,
            created_at: data.created_at,
            updated_at: data.updated_at
        });
    }
}

const Services = () => {
    const [searchText, setSearchText] = useState('');
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [modalData, setModalData] = useState(new ServiceModel());
    const [imagePreview, setImagePreview] = useState(null);
    const [isImporting, setIsImporting] = useState(false);
    const [importProgress, setImportProgress] = useState(0);
    const [currentImportItem, setCurrentImportItem] = useState('');
    const [usertype, setUsertype] = useState('');
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({});
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [speciality, setSpeciality] = useState('');
    const [specialities, setSpecialities] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isCategorizing, setIsCategorizing] = useState(false);
    const [categorizeProgress, setCategorizeProgress] = useState(0);
    const [currentCategorizingItem, setCurrentCategorizingItem] = useState('');
    const [showFixModal, setShowFixModal] = useState(false);
    const [isFixing, setIsFixing] = useState(false);
    const [openAiKey, setOpenAiKey] = useState(process.env.REACT_APP_OPENAI_API_KEY || '');

    useEffect(() => {
        getServices();
        getSpecialities();
    }, []);

    useEffect(() => {
        getServices();
    }, [searchText, page, pageSize, speciality]);

    const getServices = async () => {
        setLoading(true);
        const tableSchema = '';
        const tableName = 'services';
        const conditions = {
            ...(speciality && { speciality_id: speciality })
        };
        const orderBy = '';
        const search = {
            ...(searchText && { name: searchText })
        };
        const pagination = { page: page, limit: pageSize };
        const margedata = [
            {
                "target_table": "specialities",
                "target_column": "id",
                "target_value": "speciality_id",
                "target_label": "speciality"
            }
        ];
        const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        debugLog('getServices response', response);
        if (response.data.length > 0) {
            const services = response.data.map(item => ServiceModel.fromAPI(item));
            setData(services);
            setTotal(response.totalPages);
        } else {
            setData([]);
            setTotal(0);
        }
        const usertype = await getuserdata('user_type');
        setUsertype(usertype);
        setLoading(false);
    }

    const getSpecialities = async () => {
        try {
            const tableSchema = '';
            const tableName = 'specialities';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = '';
            const pagination = '';
            const margedata = '';
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            debugLog('getSpecialities response', response);
            if (response.data && response.data.length > 0) {
                setSpecialities(response.data);
            } else {
                setSpecialities([]);
            }
        } catch (error) {
            console.error('Error fetching specialities:', error);
            message.error('Failed to fetch specialities');
        }
    }

    const callAI = async (prompt, systemPrompt = "You are a medical data assistant.") => {
        const openAIKey = process.env.REACT_APP_OPENAI_API_KEY;
        
        // Try OpenAI first if key exists
        if (openAIKey) {
            try {
                const response = await axios.post('https://api.openai.com/v1/chat/completions', {
                    model: "gpt-4o-mini",
                    messages: [
                        { role: "system", content: systemPrompt },
                        { role: "user", content: prompt }
                    ],
                    temperature: 0.3
                }, {
                    headers: {
                        'Authorization': `Bearer ${openAIKey}`,
                        'Content-Type': 'application/json'
                    },
                    timeout: 20000
                });
                return response.data.choices[0].message.content;
            } catch (error) {
                console.warn("OpenAI API failed, falling back to Ollama.", error.message);
            }
        }

        // Fallback to Ollama
        try {
            const response = await axios.post('http://localhost:11434/api/generate', {
                model: 'llama3',
                prompt: `${systemPrompt}\n\n${prompt}`,
                stream: false
            }, { timeout: 15000 });
            return response.data.response;
        } catch (error) {
            throw new Error("Both OpenAI and Ollama AI engines failed.");
        }
    };

    const handleUnifiedSync = async () => {
        if (specialities.length === 0) {
            message.error('No specialities found to sync.');
            return;
        }

        setIsCategorizing(true);
        setCategorizeProgress(0);
        
        try {
            const tableSchema = '';
            const tableName = 'services';
            
            // 1. Fetch ALL services
            const allServicesResponse = await oneKlicks.read(tableSchema, tableName, {}, '', '', { page: 1, limit: 3000 }, []);
            let allServices = allServicesResponse.data;

            // 2. Filter services that need mapping or country
            const needsSync = allServices.filter(s => !s.speciality_id || s.speciality_id === '' || !s.country);
            
            if (needsSync.length > 0) {
                const totalItems = needsSync.length;
                let processedItems = 0;
                const batchSize = 40;
                
                const specList = specialities.map(s => `${s.id}: ${s.name}`).join(', ');

                for (let i = 0; i < needsSync.length; i += batchSize) {
                    const batch = needsSync.slice(i, i + batchSize);
                    setCurrentCategorizingItem(`Mapping batch ${Math.floor(i/batchSize) + 1} of ${Math.ceil(totalItems/batchSize)}...`);
                    
                    const serviceNames = batch.map(s => `ID:${s.id} - ${s.name}`).join('\n');
                    
                    const prompt = `Task: Assign each medical service to the most relevant Speciality ID and detect its most likely Country.
Specialities (ID: Name):
${specList}

Services:
${serviceNames}

Instructions:
1. Return ONLY a JSON array.
2. Format: [{"id": "ServiceID", "spec_id": "MatchedSpecialityID", "country": "CountryName"}]
3. If no match, use spec_id: "" and country: "Global".

JSON:`;

                    try {
                        const aiResponseText = await callAI(prompt, "You are a medical data auditor. Return ONLY JSON.");
                        const start = aiResponseText.indexOf('[');
                        const end = aiResponseText.lastIndexOf(']') + 1;
                        if (start === -1 || end === 0) throw new Error("Invalid AI response format");
                        
                        const results = JSON.parse(aiResponseText.substring(start, end));

                        for (const res of results) {
                            if (res.id && (res.spec_id || res.country)) {
                                const updateData = {
                                    ...(res.spec_id && { speciality_id: res.spec_id }),
                                    country: res.country || 'Global'
                                };
                                await oneKlicks.update(tableSchema, tableName, updateData, { id: res.id });
                                debugLog(`Synced Service ${res.id}: Spec ${res.spec_id}, Country ${res.country}`);
                            }
                        }
                    } catch (e) {
                        console.error("Batch sync failed", e);
                    }

                    processedItems += batch.length;
                    setCategorizeProgress(Math.min(90, Math.round((processedItems / totalItems) * 100)));
                }
            }

            // 3. PHASE 2: GENERATE NEW SERVICES FOR THIN SPECIALITIES
            // Only generate for specialities that have fewer than 10 services
            setCurrentCategorizingItem("Generating missing core services...");
            for (let i = 0; i < specialities.length; i++) {
                const spec = specialities[i];
                const count = allServices.filter(s => s.speciality_id == spec.id).length;
                
                if (count < 8) {
                    setCurrentCategorizingItem(`Generating core services for ${spec.name}...`);
                    try {
                        const genPrompt = `Suggest 8 common medical services for "${spec.name}". Return ONLY a JSON array: [{"name": "Service Name", "country": "Global"}]`;
                        const aiRes = await callAI(genPrompt, "Return ONLY JSON.");
                        const start = aiRes.indexOf('[');
                        const end = aiRes.lastIndexOf(']') + 1;
                        if (start !== -1 && end !== 0) {
                            const suggested = JSON.parse(aiRes.substring(start, end));
                            for (const item of suggested) {
                                const slug = item.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
                                await oneKlicks.create(tableSchema, tableName, {
                                    name: item.name,
                                    slug: slug,
                                    status: 'publish',
                                    speciality_id: spec.id,
                                    country: item.country || 'Global'
                                }, { name: item.name });
                            }
                        }
                    } catch (e) { console.error(`Generation failed for ${spec.name}`); }
                }
                setCategorizeProgress(90 + Math.round(((i + 1) / specialities.length) * 10));
            }

            setCategorizeProgress(100);
            message.success(`Smart Sync completed! All services mapped and core data generated.`);
            getServices();
        } catch (error) {
            console.error('Smart Sync failed:', error);
            message.error('Smart Sync failed. Please check your connection.');
        } finally {
            setIsCategorizing(false);
            setCurrentCategorizingItem('');
        }
    };

    const getPromptForService = (service) => {
        const backgroundColors = ['deep navy blue', 'soft pastel blue', 'mint green', 'light coral', 'lavender', 'pale yellow', 'peach', 'light cyan', 'warm dark gray', 'rose pink', 'light teal', 'sky blue', 'periwinkle', 'forest green', 'deep plum'];
        const hashStr = (service.id || '') + '_' + (service.name || '');
        let hash = 0;
        for (let i = 0; i < hashStr.length; i++) {
            hash = hashStr.charCodeAt(i) + ((hash << 5) - hash);
        }
        const bgIndex = Math.abs(hash) % backgroundColors.length;
        const bgColor = backgroundColors[bgIndex];

        const specName = specialities.find(s => s.id == service.speciality_id)?.name || '';
        const deptContext = specName ? ` related to the ${specName} department` : '';

        return `A clean, professional, minimalist 3D medical icon representing the concept of: ${service.name}${deptContext}. The icon should be a single, stylized 3D symbolic object (like a medical tool or health symbol), centered on a clean circular base. Use a soft, premium professional color palette with gentle lighting. IMPORTANT: Do not show any blood, organs, surgery, or graphic medical details. Focus on clean, friendly healthcare symbols. The total image size must be 1080x1080 pixels on a completely solid, uniform ${bgColor} background. Modern app icon style, high-quality 3D render.`;
    };

    const handleCopyPrompt = (record) => {
        const prompt = getPromptForService(record);
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(prompt)
                .then(() => message.success(`Copied AI prompt for ${record.name} to clipboard!`))
                .catch(() => message.error('Failed to copy to clipboard.'));
        } else {
            const textArea = document.createElement("textarea");
            textArea.value = prompt;
            textArea.style.position = "fixed";
            textArea.style.left = "-9999px";
            textArea.style.top = "-9999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                message.success(`Copied AI prompt for ${record.name} to clipboard!`);
            } catch (error) {
                message.error("Failed to copy prompt");
            }
            textArea.remove();
        }
    };

    const handleUpdateSingleImage = async (record) => {
        if (!openAiKey || !openAiKey.startsWith('sk-')) {
            setShowFixModal(true);
            message.info('Please enter your OpenAI API key to continue.');
            return;
        }

        const hide = message.loading(`Generating 3D icon for ${record.name}...`, 0);

        try {
            const prompt = getPromptForService(record);
            const response = await axios.post('https://api.openai.com/v1/images/generations', {
                model: "gpt-image-2", // Using the same model alias as Specialities.js
                prompt: prompt,
                n: 1,
                size: "1080x1080"
            }, {
                headers: {
                    'Authorization': `Bearer ${openAiKey}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.data && response.data.data && response.data.data.length > 0) {
                const imgData = response.data.data[0];
                let uploadimage = null;

                if (imgData.b64_json) {
                    const res = await fetch(`data:image/png;base64,${imgData.b64_json}`);
                    const blob = await res.blob();
                    const file = new File([blob], `${record.slug || 'service'}-${Date.now()}.png`, { type: 'image/png' });
                    uploadimage = await OneKlicksFileSDK.uploadFile('services', 'public', file);
                } else if (imgData.url) {
                    uploadimage = await OneKlicksFileSDK.uploadFileFromUrl('services', 'public', imgData.url);
                }

                if (uploadimage && (uploadimage.fileid || uploadimage.fileId)) {
                    const newUrl = uploadimage.fileid || uploadimage.fileId;
                    await oneKlicks.update('', 'services', { url: newUrl }, { id: record.id });
                    message.success(`New icon generated for ${record.name}!`);
                    getServices();
                }
            }
        } catch (err) {
            console.error(`Failed to generate icon for ${record.name}`, err);
            message.error(`AI Error: ${err.message}`);
        } finally {
            hide();
        }
    };

    const autoUpdateAllImages = async () => {
        setIsFixing(true);
        setCategorizeProgress(0);
        let successCount = 0;
        const totalItems = data.length;

        if (totalItems === 0) {
            message.info('No services available to update.');
            setIsFixing(false);
            return;
        }

        if (!openAiKey || !openAiKey.startsWith('sk-')) {
            message.error('Please enter a valid OpenAI API Key.');
            setIsFixing(false);
            return;
        }

        for (let i = 0; i < totalItems; i++) {
            const service = data[i];
            setCurrentCategorizingItem(`Generating icon for: ${service.name}`);

            try {
                const prompt = getPromptForService(service);
                const response = await axios.post('https://api.openai.com/v1/images/generations', {
                    model: "gpt-image-2",
                    prompt: prompt,
                    n: 1,
                    size: "1080x1080"
                }, {
                    headers: {
                        'Authorization': `Bearer ${openAiKey}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data && response.data.data && response.data.data.length > 0) {
                    const imgData = response.data.data[0];
                    let uploadimage = null;
                    if (imgData.url) {
                        uploadimage = await OneKlicksFileSDK.uploadFileFromUrl('services', 'public', imgData.url);
                    }

                    if (uploadimage && (uploadimage.fileid || uploadimage.fileId)) {
                        const newUrl = uploadimage.fileid || uploadimage.fileId;
                        await oneKlicks.update('', 'services', { url: newUrl }, { id: service.id });
                        successCount++;
                    }
                }
            } catch (err) {
                console.error(`Failed icon for ${service.name}`, err);
            }

            setCategorizeProgress(Math.round(((i + 1) / totalItems) * 100));
        }

        setIsFixing(false);
        setCurrentCategorizingItem('');
        message.success(`Successfully updated ${successCount} service icons.`);
        getServices();
        setShowFixModal(false);
    };

    const openFixModal = () => setShowFixModal(true);
    const closeFixModal = () => setShowFixModal(false);


    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    const columns = [
        {
            title: 'ID',
            key: 'id',
            width: '10%',
            align: 'center',
            render: (text, record, index) => index + 1,
            sorter: false
        },
        {
            title: 'Speciality',
            dataIndex: 'speciality_id',
            key: 'speciality_id',
            width: '15%',
            align: 'center',
            render: (speciality_id) => (
                <SpecialityName id={speciality_id} />
            )
        },
        {
            title: 'Image',
            dataIndex: 'url',
            key: 'url',
            width: '15%',
            align: 'center',
            render: (text) => (
                console.log("image url: ", text),
                <ImageShow image={text} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%' }} />
            )
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => decodeHtml(a.name).localeCompare(decodeHtml(b.name)),
            filteredValue: searchText ? [searchText] : null,
            onFilter: (value, record) =>
                decodeHtml(record.name).toLowerCase().includes(value.toLowerCase()),
            width: '40%',
            ellipsis: true,
            render: (text) => decodeHtml(text)
        },
        {
            title: 'Total Use',
            dataIndex: 'totalUse',
            key: 'totalUse',
            sorter: (a, b) => a.totalUse - b.totalUse,
            width: '20%',
            align: 'center'
        },
        {
            title: 'Country',
            dataIndex: 'country',
            key: 'country',
            width: '15%',
            align: 'center',
            render: (country) => (
                <p className="text-capitalize">{country}</p>
            )
        },
        {
            title: 'Action',
            key: 'action',
            width: '20%',
            align: 'center',
            render: (_, record) => (
                <Space size="small">
                    <Tooltip title="Edit Service">
                        <Button type="primary" ghost icon={<EditOutlined />} onClick={() => handleEdit(record)} size="small" />
                    </Tooltip>
                    <Tooltip title="Delete Service">
                        <Button danger icon={<DeleteOutlined />} onClick={() => handleDelete(record)} size="small" />
                    </Tooltip>
                    <Tooltip title="Update Image">
                        <Button style={{ color: '#17a2b8', borderColor: '#17a2b8' }} icon={<i className="ti-image" />} onClick={() => handleUpdateSingleImage(record)} size="small" />
                    </Tooltip>
                    <Tooltip title="Copy Prompt">
                        <Button style={{ color: '#6c757d', borderColor: '#6c757d' }} icon={<i className="ti-files" />} onClick={() => handleCopyPrompt(record)} size="small" />
                    </Tooltip>
                </Space>
            ),
        },
    ];

    const openModal = () => {
        setShowModal(true);
        setModalData(new ServiceModel());
        setImagePreview(null);
    };

    const closeModal = () => setShowModal(false);

    const openImportModal = () => {
        setShowImportModal(true);
    };

    const closeImportModal = () => {
        setShowImportModal(false);
    };

    const handleImport = async () => {
        setIsImporting(true);
        setImportProgress(0);

        try {
            const response = await axios.post('http://localhost:5000/api/specialities/get-services', {
                "parent": ""
            });
            debugLog('handleImport services response', response.data.data);
            const services = response.data.data;

            if (!Array.isArray(services)) {
                throw new Error('Invalid data format received');
            }

            const totalItems = services.length;
            let processedItems = 0;
            let successCount = 0;
            let errorCount = 0;

            for (const service of services) {
                setCurrentImportItem(service.name || 'Processing item...');

                try {
                    const root = 'services';
                    const status = 'publish';
                    let url = '';
                    let uploadimage = '';
                    if (service.url) {
                        url = service.url;
                    } else {
                        url = service.meta.image;
                    }
                    if (url) {
                        uploadimage = await OneKlicksFileSDK.uploadFileFromUrl(root, status, url);
                    }
                    const tableSchema = '';
                    const tableName = 'services';
                    let speciality_id = '';

                    if (service.meta.speciality) {
                        const tableSchema = '';
                        const tableName = 'specialities';
                        const conditions = {
                            old_id: service.meta.speciality
                        };
                        const orderBy = '';
                        const search = '';
                        const pagination = '';
                        const margedata = [];
                        const speciality = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
                        debugLog('speciality', speciality.data);
                        if (speciality.data.length > 0) {
                            speciality_id = speciality.data[0].id;
                        }
                    }

                    const serviceModel = {
                        old_id: service.id,
                        name: service.name,
                        slug: service.slug,
                        color: service.color || '',
                        url: uploadimage.fileId || '',
                        status: 'publish',
                        speciality_id: speciality_id
                    };
                    const conditions = {
                        name: service.name
                    };
                    const response = await oneKlicks.create(tableSchema, tableName, serviceModel, conditions);

                    if (response && response.success) {
                        successCount++;
                        message.success(`Successfully imported: ${service.name}`);
                    } else {
                        errorCount++;
                        message.error(`Failed to import: ${service.name}`);
                    }

                    processedItems++;
                    const progress = Math.round((processedItems / totalItems) * 100);
                    setImportProgress(progress);

                    await new Promise(resolve => setTimeout(resolve, 500));
                } catch (error) {
                    errorCount++;
                    console.error(`Error processing service ${service.name}:`, error);
                    message.error(`Failed to import ${service.name}: ${error.message}`);
                }
            }

            message.success(`Import completed! Successfully imported ${successCount} items. ${errorCount} items failed.`);
            await getServices(); // Refresh the list after import

        } catch (error) {
            console.error('Import failed:', error);
            message.error('Import failed. Please try again.');
        } finally {
            setIsImporting(false);
            setCurrentImportItem('');
            setImportProgress(0);
            closeImportModal();
        }
    };

    const handleSubmit = () => {
        setData([...data, modalData]);
        closeModal();
    };

    const handleEdit = (record) => {
        setModalData(record);
        setEditData(record);
        setShowEditModal(true);
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleDelete = (record) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete "${decodeHtml(record.name)}"?`);

        if (confirmDelete) {
            try {
                const tableSchema = '';
                const tableName = 'services';
                oneKlicks.delete(tableSchema, tableName, { id: record.id })
                    .then(response => {
                        if (response && response.success) {
                            message.success('Service deleted successfully');
                            OneKlicksFileSDK.deleteFile(record.url).then(response => {
                                console.log(response);
                                getServices();
                            })
                        } else {
                            message.error('Failed to delete service');
                        }
                    })
                    .catch(error => {
                        console.error('Error deleting service:', error);
                        message.error('Failed to delete service');
                    });

            } catch (error) {
                console.error('Error deleting service:', error);
                message.error('Failed to delete service');
            }
        }
    };
    return (
        <section className="dc-haslayout dc-dbsectionspace" style={{ backgroundColor: '#f4f7fe', minHeight: '100vh', padding: '24px' }}>
            <div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <Card 
                        style={{ 
                            borderRadius: '16px', 
                            border: 'none', 
                            boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                            background: 'white'
                        }}
                        bodyStyle={{ padding: '24px' }}
                    >
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            flexWrap: 'wrap', 
                            gap: '16px', 
                            marginBottom: '28px',
                            paddingBottom: '20px',
                            borderBottom: '1px solid #f0f0f0'
                        }}>
                            <div>
                                <h3 style={{ margin: 0, fontWeight: 700, color: '#2b3674', fontSize: '24px' }}>Services Management</h3>
                                <p style={{ margin: 0, color: '#a3aed1', fontSize: '14px', marginTop: '4px' }}>Manage and organize all your medical services</p>
                            </div>
                            
                            <Space size="middle" wrap>
                                <Input
                                    placeholder="Search Service..."
                                    prefix={<SearchOutlined style={{ color: '#a3aed1', fontSize: '16px' }} />}
                                    style={{ 
                                        width: 250, 
                                        borderRadius: '12px', 
                                        backgroundColor: '#f4f7fe', 
                                        border: 'none',
                                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                                    }}
                                    size="large"
                                    onChange={(e) => setSearchText(e.target.value)}
                                    allowClear
                                />
                                <select
                                    className="form-select"
                                    style={{
                                        width: '200px',
                                        height: '40px',
                                        borderRadius: '12px',
                                        backgroundColor: '#f4f7fe',
                                        border: 'none',
                                        color: '#6c757d',
                                        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)',
                                        padding: '0 15px'
                                    }}
                                    value={speciality}
                                    onChange={(e) => setSpeciality(e.target.value)}
                                >
                                    <option value="" defaultValue>All Specialities</option>
                                    {specialities.map((type) => (
                                        <option key={type.id} value={type.id}>{type.name}</option>
                                    ))}
                                </select>
                                <Button 
                                    icon={<i className="ti-image" />} 
                                    onClick={openFixModal} 
                                    style={{ borderRadius: '10px', fontWeight: 600, background: '#e6f7ff', color: '#1890ff', border: '1px solid #91d5ff', height: '40px' }}
                                >
                                    Auto-Update Images
                                </Button>
                                {usertype === 'administrator' && (
                                    <Button 
                                        icon={<i className="ti-wand" />} 
                                        onClick={handleUnifiedSync} 
                                        style={{ 
                                            borderRadius: '10px', 
                                            fontWeight: 600, 
                                            background: 'linear-gradient(135deg, #fa8c16 0%, #d46b08 100%)', 
                                            color: 'white', 
                                            border: 'none', 
                                            boxShadow: '0 4px 12px rgba(250, 140, 22, 0.3)',
                                            height: '40px' 
                                        }}
                                        loading={isCategorizing}
                                    >
                                        AI Smart Sync
                                    </Button>
                                )}
                                {usertype === 'administrator' && (
                                    <Button 
                                        icon={<i className="ti-import" />} 
                                        onClick={openImportModal} 
                                        style={{ borderRadius: '10px', fontWeight: 600, background: '#f6ffed', color: '#52c41a', border: '1px solid #b7eb8f', height: '40px' }}
                                    >
                                        Import
                                    </Button>
                                )}
                                <Button 
                                    type="primary" 
                                    icon={<PlusOutlined />} 
                                    onClick={openModal} 
                                    style={{ 
                                        borderRadius: '10px', 
                                        fontWeight: 600, 
                                        background: 'linear-gradient(135deg, #1890ff 0%, #0050b3 100%)', 
                                        border: 'none', 
                                        boxShadow: '0 4px 14px rgba(24, 144, 255, 0.4)',
                                        height: '40px'
                                    }}
                                >
                                    Add Service
                                </Button>
                            </Space>
                        </div>

                        <Table
                            columns={columns}
                            dataSource={data}
                            rowKey="id"
                            loading={loading}
                            pagination={false}
                            style={{ 
                                marginTop: '10px'
                            }}
                            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                        />
                        
                        <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '20px', borderTop: '1px solid #f0f0f0', marginTop: '10px' }}>
                            <Paginationnew currentPage={page} totalPages={total} handlePageChange={handlePageChange} />
                        </div>
                    </Card>
                </div>
                {showModal && (
                    <AddServices closeModal={closeModal} getServices={getServices} />
                )}

                {showEditModal && (
                    <EditServices closeModal={setShowEditModal} data={editData} getServices={getServices} />
                )}

                <Modal
                    title="Import Services"
                    open={showImportModal}
                    onCancel={closeImportModal}
                    footer={[
                        <Button key="cancel" onClick={closeImportModal} disabled={isImporting}>
                            Cancel
                        </Button>,
                        <Button
                            key="import"
                            type="primary"
                            onClick={handleImport}
                            loading={isImporting}
                            disabled={isImporting}
                        >
                            Start Import
                        </Button>
                    ]}
                >
                    {isImporting ? (
                        <div>
                            <p>Importing services...</p>
                            <Progress percent={importProgress} status="active" />
                            <p style={{ marginTop: '10px' }}>{currentImportItem}</p>
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                Please do not close this window while import is in progress
                            </p>
                        </div>
                    ) : (
                        <p>Are you sure you want to import services? This process may take a few minutes.</p>
                    )}
                </Modal>

                <Modal
                    title="AI Auto-Mapping Services"
                    open={isCategorizing}
                    footer={null}
                    closable={false}
                >
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                        <p style={{ marginTop: '15px', fontWeight: 600 }}>Analyzing and Mapping Services...</p>
                        <Progress percent={categorizeProgress} status="active" />
                        <p style={{ marginTop: '10px', color: '#666' }}>Currently: {currentCategorizingItem}</p>
                        <p style={{ fontSize: '12px', color: '#999', marginTop: '15px' }}>
                            Using Ollama AI to determine the best speciality for each service name.
                        </p>
                    </div>
                </Modal>

                <Modal
                    title="Generate Premium AI Images (OpenAI DALL-E 3)"
                    open={showFixModal}
                    onCancel={closeFixModal}
                    footer={[
                        <Button key="cancel" onClick={closeFixModal} disabled={isFixing}>
                            Cancel
                        </Button>,
                        <Button
                            key="import"
                            type="primary"
                            onClick={autoUpdateAllImages}
                            loading={isFixing}
                            disabled={isFixing || !openAiKey}
                        >
                            Generate Images
                        </Button>
                    ]}
                >
                    {isFixing ? (
                        <div>
                            <p>Calling OpenAI DALL-E 3 to generate premium images...</p>
                            <Progress percent={categorizeProgress} status="active" />
                            <p style={{ marginTop: '10px', fontWeight: 'bold' }}>{currentCategorizingItem}</p>
                            <p style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                This process updates every service. Please do not close this window while it is running.
                            </p>
                        </div>
                    ) : (
                        <div>
                            <p>This will use <strong>OpenAI's state-of-the-art DALL-E 3 model</strong> to generate ultra-high-quality, custom 3D medical icons for all your services.</p>
                            <div className="mb-3 mt-4">
                                <label className="form-label fw-bold">OpenAI API Key</label>
                                <Input.Password
                                    placeholder="sk-..."
                                    value={openAiKey}
                                    onChange={(e) => setOpenAiKey(e.target.value)}
                                    size="large"
                                />
                                <small className="text-muted d-block mt-2">
                                    Your key is not stored anywhere. It is only used for this one-time automation loop. DALL-E 3 costs approx $0.04 per image.
                                </small>
                            </div>
                        </div>
                    )}
                </Modal>
            </div>
        </section>
    );
};

export default Services; 
